import { useState, useRef, useCallback, useEffect } from 'react';

function useHandlePlayerError() {
  const [reportableError, setReportableError] = useState();
  const [error, setError] = useState();
  const alreadyGotAnError = useRef(false);
  const timeout = useRef();
  const handleReportableError = useCallback((receivedError) => {
    if (alreadyGotAnError.current)
      return;
    alreadyGotAnError.current = true;
    setReportableError(receivedError);
    timeout.current = setTimeout(() => {
      setError(receivedError);
    }, 100);
  }, []);
  const handleError = useCallback((receivedError) => {
    if (alreadyGotAnError.current)
      return;
    alreadyGotAnError.current = true;
    setError(receivedError);
  }, []);
  useEffect(() => () => {
    if (timeout.current)
      clearTimeout(timeout.current);
  }, []);
  return {
    reportableError,
    error,
    handleReportableError,
    handleError
  };
}

export { useHandlePlayerError };
//# sourceMappingURL=useHandlePlayerError.js.map
